import { render } from "./GiftCardSkeleton.vue?vue&type=template&id=5e35d771&scoped=true"
import script from "./GiftCardSkeleton.vue?vue&type=script&lang=js"
export * from "./GiftCardSkeleton.vue?vue&type=script&lang=js"

import "./GiftCardSkeleton.vue?vue&type=style&index=0&id=5e35d771&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e35d771"]])

export default __exports__